module.exports = __webpack_public_path__ + "img/Profil_CS-Ecoi.9e84bf45.jpg";